var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityOfCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 61,
    viewBox: "0 0 52 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5752 42.7351C39.4553 42.7351 39.3336 42.7013 39.2255 42.6302C38.9306 42.4369 38.8485 42.0411 39.0418 41.7462C39.1025 41.6536 39.18 41.5378 39.2711 41.4015C42.8889 35.9942 43.1907 33.7939 42.8073 32.9003C42.707 32.6664 42.4895 32.3409 41.7605 32.2155C41.4131 32.1558 41.1801 31.8257 41.2398 31.4783C41.2996 31.1308 41.6297 30.8988 41.9771 30.9576C43.214 31.1705 43.7493 31.858 43.9809 32.3969C44.9684 34.6976 42.5497 38.7972 40.3325 42.1113C40.2436 42.244 40.1684 42.3566 40.1096 42.4464C39.9869 42.6338 39.7831 42.735 39.5752 42.735L39.5752 42.7351Z",
    fill: "url(#paint0_linear_38_64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4774 52.9863H31.7447C31.4196 52.9863 31.1461 52.7419 31.11 52.4187C30.9833 51.278 31.1246 47.0374 31.235 46.152C31.4739 44.1592 32.9812 40.3526 34.7406 37.3007C36.4006 34.421 38.9483 30.9884 41.6592 30.9884C41.8379 30.9884 42.0166 31.0039 42.1908 31.034C41.1987 27.925 40.5577 23.7492 41.0583 21.0573C41.3569 19.4123 42.7626 16.9741 44.8306 16.9741C45.0558 16.9741 45.2842 17.0038 45.509 17.0626C47.7723 17.6594 49.424 23.2299 50.2073 26.497C51.1598 30.47 51.9143 35.8066 51.3216 38.1359C50.5953 41.0046 49.3288 42.6601 48.1037 44.2609C46.5171 46.334 45.147 48.1248 45.1152 52.3531C45.1124 52.7037 44.8275 52.9864 44.4769 52.9864L44.4774 52.9863ZM32.347 51.7096H43.8545C44.0269 47.4892 45.5834 45.4552 47.0911 43.4847C48.2378 41.9865 49.4231 40.4369 50.0856 37.8216C50.5406 36.0335 50.0706 31.3962 48.9672 26.7945C47.6487 21.2938 46.083 18.5341 45.1866 18.2974C45.0686 18.2669 44.9486 18.2509 44.8319 18.2509C43.5229 18.2509 42.5131 20.1982 42.3153 21.2882C41.7846 24.1406 42.7092 29.0372 43.869 31.9396C43.9789 32.2141 43.8854 32.5282 43.6438 32.6983C43.4021 32.8683 43.0752 32.8505 42.8537 32.655C42.659 32.4826 42.3613 32.3586 41.9933 32.2957C41.8807 32.2752 41.7708 32.2656 41.6605 32.2656C40.0447 32.2656 37.926 34.3332 35.8479 37.9386C33.9981 41.1483 32.6947 44.7142 32.5037 46.3076C32.4189 46.9833 32.3017 50.1911 32.3469 51.7094L32.347 51.7096Z",
    fill: "url(#paint1_linear_38_64)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3419 60.6453H30.4701C30.1177 60.6453 29.8318 60.3594 29.8318 60.007V52.3474C29.8318 51.995 30.1177 51.7091 30.4701 51.7091H47.0661C47.378 51.7091 47.6442 51.9348 47.6958 52.2425L48.9724 59.9021C49.0034 60.0872 48.951 60.2764 48.8302 60.4196C48.7084 60.5627 48.5306 60.6453 48.3428 60.6453L48.3419 60.6453ZM31.1074 59.3686H47.5879L46.5242 52.9856H31.107L31.1074 59.3686Z",
    fill: "url(#paint2_linear_38_64)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2355 56.8158C43.0668 56.8158 42.9036 56.7483 42.7837 56.6279C42.6651 56.5103 42.5972 56.3457 42.5972 56.1775C42.5972 56.0088 42.6647 55.8442 42.7837 55.7257C42.9022 55.6067 43.0668 55.5392 43.2355 55.5392C43.4037 55.5392 43.5688 55.6067 43.6873 55.7257C43.8058 55.8456 43.8738 56.0092 43.8738 56.1775C43.8738 56.3448 43.8063 56.5094 43.6873 56.6279C43.5674 56.7483 43.4028 56.8158 43.2355 56.8158Z",
    fill: "url(#paint3_linear_38_64)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4269 42.735C12.219 42.735 12.0152 42.6333 11.8925 42.4468C11.8337 42.357 11.758 42.244 11.6691 42.1113C9.45196 38.7968 7.0337 34.6974 8.02078 32.3969C8.25239 31.8576 8.78764 31.1705 10.0246 30.9576C10.3715 30.8983 10.7021 31.1313 10.7618 31.4782C10.8215 31.8257 10.5885 32.1557 10.2411 32.2155C9.51212 32.3408 9.29464 32.6664 9.19433 32.9003C8.81089 33.7939 9.11318 35.9937 12.7305 41.401C12.8217 41.5373 12.8997 41.6536 12.9603 41.7461C13.1536 42.0411 13.0715 42.4369 12.7766 42.6302C12.6685 42.7013 12.5472 42.735 12.4269 42.735V42.735Z",
    fill: "url(#paint4_linear_38_64)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2562 52.9863H7.52359C7.17298 52.9863 6.88803 52.7036 6.88529 52.353C6.85292 48.1252 5.48281 46.3344 3.89628 44.2608C2.67122 42.66 1.40461 41.0046 0.678393 38.1355C0.0856925 35.8071 0.840243 30.47 1.79268 26.4975C2.57595 23.2304 4.22728 17.6598 6.48914 17.0635C6.71573 17.0042 6.94415 16.9746 7.16937 16.9746C9.23702 16.9746 10.6431 19.4129 10.9421 21.0606C11.4423 23.7497 10.8013 27.9255 9.80917 31.0345C9.97922 31.0044 10.1602 30.9889 10.3408 30.9889C13.0521 30.9889 15.5995 34.4215 17.2594 37.3012C19.0183 40.3531 20.5256 44.1601 20.765 46.1557C20.8749 47.0379 21.0162 51.2789 20.8895 52.4192C20.8544 52.742 20.5808 52.9863 20.2557 52.9863L20.2562 52.9863ZM8.14686 51.7097H19.6545C19.6996 50.1914 19.5824 46.9835 19.4985 46.3096C19.307 44.7134 18.004 41.1472 16.1539 37.9379C14.0757 34.3324 11.9571 32.2648 10.3413 32.2648C10.2309 32.2648 10.1211 32.2749 10.0148 32.294C9.64051 32.3583 9.34279 32.4823 9.1481 32.6546C8.92653 32.8507 8.59963 32.8685 8.35799 32.6984C8.11635 32.5279 8.02288 32.2142 8.13276 31.9398C9.29309 29.0374 10.2172 24.1407 9.68743 21.2912C9.4891 20.1983 8.47917 18.2511 7.17031 18.2511C7.05359 18.2511 6.93369 18.267 6.81423 18.298C5.91924 18.5342 4.3536 21.2939 3.03505 26.7947C1.93217 31.3964 1.4617 36.034 1.91667 37.8213C2.57913 40.4374 3.76453 41.9867 4.91116 43.4852C6.41797 45.4553 7.97451 47.4896 8.1469 51.7097L8.14686 51.7097Z",
    fill: "url(#paint5_linear_38_64)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5331 60.6453H3.66142C3.47357 60.6453 3.29577 60.5627 3.17449 60.4196C3.05321 60.2764 3.00078 60.0872 3.03178 59.9021L4.30843 52.2425C4.35995 51.9348 4.62621 51.7091 4.93806 51.7091H21.534C21.8865 51.7091 22.1723 51.995 22.1723 52.3474V60.007C22.1723 60.3594 21.8865 60.6453 21.534 60.6453L21.5331 60.6453ZM4.41424 59.3686H20.8947V52.9856H5.47753L4.41424 59.3686Z",
    fill: "url(#paint6_linear_38_64)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76663 56.8158C8.5993 56.8158 8.43471 56.7483 8.31481 56.6279C8.19581 56.5094 8.12833 56.3448 8.12833 56.1775C8.12833 56.0088 8.1958 55.8456 8.31481 55.7257C8.43334 55.6071 8.59839 55.5392 8.76663 55.5392C8.93532 55.5392 9.09991 55.6067 9.21845 55.7257C9.33699 55.8456 9.40493 56.0092 9.40493 56.1775C9.40493 56.3448 9.33745 56.5094 9.21845 56.6279C9.09855 56.7483 8.93395 56.8158 8.76663 56.8158Z",
    fill: "url(#paint7_linear_38_64)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6423 10.8584C41.408 10.8584 41.1827 10.7294 41.071 10.5056C38.4614 5.29111 32.5466 1.92184 26.0017 1.92184C19.4569 1.92184 13.5422 5.29111 10.9324 10.5056C10.7746 10.8206 10.3912 10.9487 10.0757 10.7905C9.76064 10.6328 9.63298 10.2493 9.79073 9.93384C12.6147 4.29127 18.9781 0.645264 26.0016 0.645264C33.025 0.645264 39.389 4.29127 42.2124 9.9343C42.3701 10.2493 42.2425 10.6328 41.927 10.791C41.8358 10.8366 41.7382 10.8585 41.642 10.8585L41.6423 10.8584Z",
    fill: "url(#paint8_linear_38_64)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2985 28.7302H17.7025C17.3501 28.7302 17.0642 28.4443 17.0642 28.0919V24.9004C17.0642 21.9698 19.0556 19.2574 22.1373 17.9913C22.4099 17.8792 22.7241 17.9685 22.8969 18.2075C23.6168 19.2009 24.7766 19.7941 26.0004 19.7941C27.2241 19.7941 28.384 19.2009 29.1039 18.207C29.2767 17.9681 29.5908 17.8787 29.8634 17.9909C32.945 19.2575 34.9365 21.9698 34.9365 24.9004V28.0919C34.9365 28.4443 34.6507 28.7302 34.2982 28.7302H34.2985ZM18.3409 27.4536H33.66V24.9004C33.66 22.5883 32.197 20.502 29.8098 19.3632C28.8459 20.4406 27.4572 21.0707 26.0005 21.0707C24.5437 21.0707 23.155 20.4406 22.1912 19.3632C19.8044 20.5021 18.3409 22.5884 18.3409 24.9004V27.4536Z",
    fill: "url(#paint9_linear_38_64)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0011 21.0712C24.3694 21.0712 22.8229 20.2806 21.8636 18.9567C21.1687 17.9974 20.8286 16.8147 20.9057 15.6271C21.0703 13.0885 23.1073 11.0441 25.6446 10.8713C25.7631 10.8631 25.8831 10.859 26.0011 10.859C28.8169 10.859 31.1075 13.1496 31.1075 15.9654C31.1075 17.0473 30.7724 18.0818 30.1387 18.9572C29.1794 20.2808 27.6329 21.0713 26.0012 21.0713L26.0011 21.0712ZM26.0011 12.1351C25.9117 12.1351 25.821 12.1383 25.7312 12.1442C23.8295 12.2737 22.3031 13.8065 22.1795 15.7091C22.1206 16.6137 22.3691 17.4776 22.8975 18.2076C23.6174 19.2015 24.7773 19.7947 26.001 19.7947C27.2248 19.7947 28.3846 19.2015 29.1045 18.2076C29.5796 17.5515 29.8308 16.7759 29.8308 15.9649C29.8308 13.853 28.1129 12.1351 26.0011 12.1351L26.0011 12.1351Z",
    fill: "url(#paint10_linear_38_64)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2355 13.411C43.0668 13.411 42.9036 13.3435 42.7837 13.2245C42.6651 13.106 42.5972 12.9409 42.5972 12.7727C42.5972 12.604 42.6647 12.4394 42.7837 12.3209C42.9036 12.2023 43.0672 12.1344 43.2355 12.1344C43.4037 12.1344 43.5674 12.2019 43.6873 12.3209C43.8058 12.4408 43.8738 12.6045 43.8738 12.7727C43.8738 12.9414 43.8063 13.1046 43.6873 13.2245C43.5674 13.3435 43.4037 13.411 43.2355 13.411Z",
    fill: "url(#paint11_linear_38_64)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76663 13.411C8.59794 13.411 8.43471 13.3435 8.31617 13.2245C8.19627 13.106 8.12833 12.9409 8.12833 12.7727C8.12833 12.604 8.1958 12.4394 8.31617 12.3209C8.4338 12.2023 8.59839 12.1344 8.76663 12.1344C8.93532 12.1344 9.09991 12.2019 9.21845 12.3222C9.33699 12.4408 9.40493 12.6045 9.40493 12.7727C9.40493 12.94 9.33745 13.1046 9.21845 13.2245C9.09855 13.3435 8.93395 13.411 8.76663 13.411Z",
    fill: "url(#paint12_linear_38_64)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_64",
    x1: 38.9372,
    y1: 36.8565,
    x2: 44.2081,
    y2: 36.8565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_64",
    x1: 31.0601,
    y1: 35.0252,
    x2: 51.5315,
    y2: 35.0252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_64",
    x1: 29.8318,
    y1: 56.1883,
    x2: 48.9812,
    y2: 56.1883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_64",
    x1: 42.5972,
    y1: 56.1791,
    x2: 43.8738,
    y2: 56.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_38_64",
    x1: 7.79371,
    y1: 36.8564,
    x2: 13.0649,
    y2: 36.8564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_38_64",
    x1: 0.46846,
    y1: 35.0254,
    x2: 20.9395,
    y2: 35.0254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_38_64",
    x1: 3.02304,
    y1: 56.1883,
    x2: 22.1723,
    y2: 56.1883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_38_64",
    x1: 8.12833,
    y1: 56.1791,
    x2: 9.40493,
    y2: 56.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_38_64",
    x1: 9.72311,
    y1: 5.7646,
    x2: 42.28,
    y2: 5.7646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_38_64",
    x1: 17.0642,
    y1: 23.35,
    x2: 34.9365,
    y2: 23.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_38_64",
    x1: 20.8949,
    y1: 15.9779,
    x2: 31.1075,
    y2: 15.9779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_38_64",
    x1: 42.5972,
    y1: 12.7743,
    x2: 43.8738,
    y2: 12.7743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_38_64",
    x1: 8.12833,
    y1: 12.7743,
    x2: 9.40493,
    y2: 12.7743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityOfCare);
export default __webpack_public_path__ + "static/media/quality-of-care.6291165dc725bc3c9614ade4b0c77b79.svg";
export { ForwardRef as ReactComponent };